import dispatcher from '../dispatchers/dispatcher';

export function getCampoArticles(hardRefresh) {
    let campoArticles = JSON.parse(sessionStorage.getItem('campoArticles'));
    if (!campoArticles || hardRefresh) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', 'http://www.wblocks.com/magAPI/articles/campo', true);
        xhr.onreadystatechange = function () {
            if (xhr.readyState == 4) {
                if (xhr.status === 200) {
                    var data = eval('(' + xhr.response + ')');
                    sessionStorage.setItem('campoArticles', JSON.stringify(data.success.body.articles));
                    dispatcher.dispatch({
                        type: 'GET_CAMPO_ARTICLES',
                        articles: data.success.body.articles
                    });
                } else if (xhr.status === 0) {
                    dispatcher.dispatch({
                        type: 'NO_NETWORK_CONNECTION'
                    });
                }
            }
        }
        xhr.send();
    } else {
        setTimeout(() => {
            dispatcher.dispatch({
                type: 'GET_CAMPO_ARTICLES',
                articles: campoArticles
            });
        }, 20);
    }
}


// WEBPACK FOOTER //
// ./src/actions/MagazineActions.js